import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/free-code-camp': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M69.3 144.5c-41 68.5-36.4 163 1 227 22.2 38.2 49.7 52.4 49.7 66.5 0 6.8-6 13-12.8 13-19.5 0-99.2-75.5-99.2-197.8 0-111.5 78-186 97.1-186 6 0 14.9 4.8 14.9 11.1 0 12.7-28.3 28.6-50.7 66.2zM265.1 358.3c-37.2-13.6-65.5-45.9-65.3-86.2 0-48 57.7-90.1 57.7-136.2 0-16.8-10.4-32.6-19.6-38.2-1.9-1-4.6-2.7-4.6-5.1 0-9.6 26.1-2.8 36.5 2.2 33.6 15.9 40.6 40.3 46.4 74.1 1.4 7.9 4.3 33.3 15.9 33.3 7.5 0 12.3-5.1 12.3-12.3 0-12.6-15.4-31.2-7.2-31.2 6.1 0 18.6 12.8 22.5 16.9 23.4 24.9 32.1 49 32.1 82.6 0 42.2-23.4 74.7-53.1 89.8-9.2 5.8-12.1-0.9-12.1-1.9 0-7 29.5-23.6 29.5-56 0-10.6-2.7-22.5-8.5-31.4-1.7-2.4-7.7-10.1-11.1-10.1-0.7 0-0.7 0.5-0.7 1.2 0 5.8 3.6 11.4 3.6 17.4 0 13-31.9 20.2-31.9-6.8 0-7.1 0.7-14.3 0.7-21.3 0-5.1-0.2-6.5-2.4-11.1-3.4-6.5-14.5-19.8-22.5-19.8-2.2 0-2.9 0-2.9 2.2 0 3.4 7.7 7 7.7 19.3 0 32.1-44.2 37.9-44.2 70 0 14.4 1.9 26.5 10.1 38.6 5.1 7.5 10.6 11.8 19.1 15.2 2.1 0.7 4.3 0.9 4.3 3.6 0 6.4-7.8 3-12.3 1.2zM470.4 67c21.4 0 97.6 78.9 97.5 198.2 0 104.9-73.4 185.7-98.8 185.7-5 0-13.2-6.3-13.2-11.4 0-8.2 28.3-34.6 35.3-43.5 61-76.7 64-205.9-17.6-291-5.5-5.8-17.6-16.7-17.6-25.4 0-6.1 8.4-12.6 14.4-12.6zM428.1 390.1c8.4 0 11.9 7 11.9 15.5 0 8.9-2.5 16.4-11.9 16.4h-261.1c-8.5 0-15.5-7-15.5-15.5 0-8.9 6.1-16.4 15.5-16.4h261.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/free-code-camp.js
// module id = null
// module chunks = 